import React, { ReactElement } from 'react';
import { Box, Fab, FabProps, Tooltip, Zoom } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface TooltipButtonProps extends FabProps {
    tooltip?: string;
    icon?: ReactElement;
}

const TooltipButton: React.FunctionComponent<TooltipButtonProps> = (props) => {
    const { tooltip = '', icon, ...fabProps } = props;

    return (
        <Box>
            <Tooltip title={tooltip} TransitionComponent={Zoom}>
                <Fab color="primary" {...fabProps}>
                    {icon ? icon : <AddIcon />}
                </Fab>
            </Tooltip>
        </Box>
    );
};

export default TooltipButton;
